export const environment = {
  serverUrl: 'https://front.cycloan.fr:443/',
  production: true,
  itemPerPage: 10,
  roles: [
    'superAdmin',
    'user'
  ],
  defaultLanguage : 'fr',
  defaultDashboardRefreshInterval : 120,
  osmUrl: 'https://tile.cycloan.fr/{z}/{x}/{y}.png'

};



// WEBPACK FOOTER //
// ./src/environments/environment.ts